import axios from 'axios';
import EventBus from '@/modules/core/event-bus';
import config from '../../../config';
import * as constants from '../constants';

const { endpoints } = config.user;

const login = ({ commit, dispatch }, user) => new Promise((resolve, reject) => {
  axios({ url: endpoints.login, data: user, method: 'POST' })
    .then((resp) => {
      const token = resp.data;
      localStorage.setItem('user-token', token);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      commit(constants.USER_AUTH_LOGIN, token);
      dispatch('checkout/fetchCart', {}, { root: true });
      dispatch('fetchShoppingList');
      dispatch(
        'level4/fetchVehicleFilter',
        {
          filterType: 'brand',
        },
        { root: true },
      );
      EventBus.$emit(constants.USER_LOGGEDIN);
      resolve(resp);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      localStorage.removeItem('user-token');
      reject(err);
    });
});

const register = ({ dispatch }, user) => new Promise((resolve, reject) => {
  axios({ url: endpoints.register, data: user, method: 'POST' })
    .then((resp) => {
      resolve(resp);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const forgotPassword = ({ dispatch }, data) => new Promise((resolve, reject) => {
  axios({ url: endpoints.forgotPassword, data, method: 'POST' })
    .then((resp) => {
      dispatch('core/showGeneralInfo', { resp }, { root: true });
      resolve(resp);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const forgotPasswordConfirm = ({ dispatch }, data) => new Promise((resolve, reject) => {
  axios({ url: endpoints.forgotPasswordConfirm, data, method: 'POST' })
    .then((resp) => {
      dispatch('core/showGeneralInfo', { resp }, { root: true });
      resolve(resp);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const logout = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.logout, method: 'POST' })
    .then(() => {
      commit(constants.USER_AUTH_LOGOUT);
      EventBus.$emit(constants.USER_LOGGEDOUT);
      localStorage.removeItem('user-token');
      localStorage.removeItem('LEVEL4_VEHICLE_DATA');
      dispatch('level4/searchByVin', false, { root: true });
      delete axios.defaults.headers.common.Authorization;
      resolve();
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      localStorage.removeItem('user-token');
      reject(err);
    });
});

const fetchCustomer = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.customer })
    .then((resp) => {
      commit(constants.USER_CUSTOMER, resp.data);
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

// TODO remove - Legacy support
const fetchCurrentCustomer = ({ dispatch }) => dispatch('fetchCustomer');

const updateCustomer = ({ dispatch }, data) => new Promise((resolve, reject) => {
  axios({ url: endpoints.customerUpdate, data, method: 'POST' })
    .then((resp) => {
      const notification = {
        message: 'Basic information was successfully updated.',
      };
      dispatch('core/showGeneralInfo', { resp, notification }, { root: true });
      resolve(resp);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const setPassword = ({ dispatch }, data) => {
  const { Email, ...passwordData } = data;
  return new Promise((resolve, reject) => {
    axios({ url: endpoints.setPassword, data: passwordData, method: 'POST' })
      .then((resp) => {
        const notification = {
          message: 'Password was successfully updated.',
        };
        dispatch('core/showGeneralInfo', { resp, notification }, { root: true });
        resolve(resp);
      })
      .catch((err) => {
        dispatch('core/showGeneralError', { err }, { root: true });
        reject(err);
      });
  });
};

const addAddress = ({ dispatch }, data) => {
  const { mainEmail, ...addressData } = data;
  return new Promise((resolve, reject) => {
    axios({ url: endpoints.addAddress, data: addressData, method: 'POST' })
      .then((resp) => {
        const notification = {
          message: 'New address was successfully added.',
        };
        dispatch('fetchCustomer');
        dispatch('core/showGeneralInfo', { resp, notification }, { root: true });
        resolve(resp);
      })
      .catch((err) => {
        dispatch('core/showGeneralError', { err }, { root: true });
        reject(err);
      });
  });
};

const updateAddress = ({ dispatch }, data) => {
  const { mainEmail, ...addressData } = data;
  return new Promise((resolve, reject) => {
    axios({ url: endpoints.updateAddress, data: addressData, method: 'POST' })
      .then((resp) => {
        const notification = {
          message: 'Your address was successfully updated.',
        };
        dispatch('fetchCustomer');
        dispatch('core/showGeneralInfo', { resp, notification }, { root: true });
        resolve(resp);
      })
      .catch((err) => {
        dispatch('core/showGeneralError', { err }, { root: true });
        reject(err);
      });
  });
};

const deleteAddress = ({ dispatch }, data) => {
  const { Email, ...addressData } = data;
  return new Promise((resolve, reject) => {
    axios({ url: endpoints.deleteAddress, data: addressData, method: 'POST' })
      .then((resp) => {
        const notification = {
          message: 'Your address was successfully deleted.',
        };
        dispatch('fetchCustomer');
        dispatch('core/showGeneralInfo', { resp, notification }, { root: true });
        resolve(resp);
      })
      .catch((err) => {
        dispatch('core/showGeneralError', { err }, { root: true });
        reject(err);
      });
  });
};

const fetchOrders = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.orders })
    .then((resp) => {
      commit(constants.USER_ORDERS, resp.data);
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchIncadeaOrders = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.incadeaOrders })
    .then((resp) => {
      commit(constants.INCADEA_ORDERS, resp.data);
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchOrder = ({ commit, dispatch }, id) => new Promise((resolve, reject) => {
  axios({ url: endpoints.order(id) })
    .then((resp) => {
      commit(constants.USER_ORDER, resp.data);
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchShoppingList = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.shoppingList })
    .then((resp) => {
      commit(constants.USER_SHOPPING_LIST, resp.data);
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const addShoppingList = ({ dispatch }, data) => new Promise((resolve, reject) => {
  axios({ url: endpoints.shoppingList, data, method: 'POST' })
    .then((resp) => {
      dispatch('fetchShoppingList');
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const updateShoppingList = ({ dispatch }, id) => new Promise((resolve, reject) => {
  axios({ url: `${endpoints.shoppingList}/${id}`, method: 'PUT' })
    .then((resp) => {
      dispatch('fetchShoppingList');
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const deleteShoppingList = ({ dispatch }, id) => new Promise((resolve, reject) => {
  axios({ url: `${endpoints.shoppingList}/${id}`, method: 'DELETE' })
    .then((resp) => {
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const creteCartFromShoppingList = ({ dispatch }, data) => new Promise((resolve, reject) => {
  const { payload, id } = data;
  axios({ url: `${endpoints.shoppingList}/CreateCart/${id}`, data: payload, method: 'POST' })
    .then((resp) => {
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

export default {
  login,
  register,
  forgotPassword,
  forgotPasswordConfirm,
  logout,
  fetchCustomer,
  fetchCurrentCustomer,
  fetchOrder,
  fetchOrders,
  updateCustomer,
  setPassword,
  addAddress,
  updateAddress,
  deleteAddress,
  fetchShoppingList,
  addShoppingList,
  updateShoppingList,
  deleteShoppingList,
  creteCartFromShoppingList,
  fetchIncadeaOrders,
};
